export default __webpack_public_path__ + "static/media/loading.a2650ad0.gif";